import { appendZero } from "helper";
import dashboardIcon from "assets/icons/dashboard-icon.svg";
import bookingIcon from "assets/icons/booking-icon.svg";
import profileIcon from "assets/icons/profile-icon.svg";
import settingsIcon from "assets/icons/settings-icon.svg";
import traineeIcon from "assets/icons/trainee-icon.svg";
import playerIcon from "assets/icons/player-icon.svg";
import levelOne from "assets/icons/level-1.svg";
import levelTwo from "assets/icons/level-2.svg";
import levelThree from "assets/icons/level-3.svg";
import { CONFIG } from "config";
import { MorningIcon } from "assets/icons/MorningIcon";
import { EveningIcon } from "assets/icons/EveningIcon";
import { AfternoonIcon } from "assets/icons/AfternoonIcon";

const mainNav = [
  {
    id: "home",
    href: "/",
    label: "Home",
    permission: CONFIG.forbidden_routes.layout.home,
  },
  {
    id: "venues",
    href: "/venues",
    label: "Venues",
    permission: CONFIG.forbidden_routes.layout.venues,
  },
  {
    id: "book-court",
    href: "/book-court",
    label: "Book a Court",
    permission: CONFIG.forbidden_routes.layout.book_court,
  },
  {
    id: "shop",
    href: "https://royalproshop.com/",
    label: "Shop",
    target: "_blank",
    rel: "noopener noreferrer",
    permission: CONFIG.forbidden_routes.layout.shop,
  },
  {
    id: "drop-in",
    href: "/drop-in",
    label: "Drop-In",
    permission: CONFIG.forbidden_routes.layout.drop_in,
  },
  {
    id: "private-team-lessons",
    href: "/private-team-lessons?sport_type=1&training_type=2",
    label: "Training",
    permission: CONFIG.forbidden_routes.layout.training,
  },
  {
    id: "membership",
    href: "/membership",
    label: "Membership",
    permission: CONFIG.forbidden_routes.layout.membership,
  },
  {
    id: "badminton-beginners-programs",
    href: "/badminton-beginners-programs",
    label: "Kids Beginner",
    permission: CONFIG.forbidden_routes.layout.badminton_beginners_programs,
  },
  // {
  //   id: "fund-raising",
  //   href: "/school-fund-raising-program",
  //   label: "School Fundraising",
  //   permission: CONFIG.forbidden_routes.layout.school_fund_raising_program,
  // },
  {
    id: "pa-day",
    href: "/pa-day",
    label: "PA Day",
    permission: CONFIG.forbidden_routes.layout.pa_day_badminton_camp,
  },
  {
    id: "about-us",
    href: "/about-us",
    label: "About Us",
    permission: CONFIG.forbidden_routes.layout.about_us,
  },
];

export const mainNavLinks = mainNav.filter((item) => !item.permission);

const mobileNav = [
  {
    id: "home",
    href: "/",
    label: "Home",
    permission: CONFIG.forbidden_routes.layout.home,
  },
  {
    id: "venues",
    href: "/venues",
    label: "Venues",
    permission: CONFIG.forbidden_routes.layout.venues,
  },
  {
    id: "book-court",
    href: "/book-court",
    label: "Book a Court",
    permission: CONFIG.forbidden_routes.layout.book_court,
  },
  {
    id: "shop",
    href: "https://royalproshop.com/",
    label: "Shop",
    target: "_blank",
    rel: "noopener noreferrer",
    permission: CONFIG.forbidden_routes.layout.shop,
  },
  {
    id: "drop-in",
    href: "/drop-in",
    label: "Drop-In",
    permission: CONFIG.forbidden_routes.layout.drop_in,
  },
  {
    id: "private-team-lessons",
    href: "/private-team-lessons",
    label: "Training",
    permission: CONFIG.forbidden_routes.layout.training,
  },
  {
    id: "membership",
    href: "/membership",
    label: "Membership",
    permission: CONFIG.forbidden_routes.layout.membership,
  },
  {
    id: "badminton-beginners-programs",
    href: "/badminton-beginners-programs",
    label: "Kids Beginner",
    permission: CONFIG.forbidden_routes.layout.badminton_beginners_programs,
  },
  {
    id: "fund-raising",
    href: "/school-fund-raising-program",
    label: "School Fundraising",
    permission: CONFIG.forbidden_routes.layout.school_fund_raising_program,
  },
  {
    id: "pa-day",
    href: "/pa-day",
    label: "PA Day",
    permission: CONFIG.forbidden_routes.layout.pa_day_badminton_camp,
  },
  // {
  //   id: "winter-camp",
  //   href: "/winter-camp",
  //   label: "Winter Camp",
  //   permission: CONFIG.forbidden_routes.layout.winter_badminton_camp,
  // },
  {
    id: "about-us",
    href: "/about-us",
    label: "About Us",
    permission: CONFIG.forbidden_routes.layout.about_us,
  },
  {
    id: "sign-up",
    href: "/sign-up",
    label: "Sign Up",
    permission: CONFIG.forbidden_routes.auth.sign_up,
  },
  {
    id: "signin",
    href: "/login",
    label: "Sign In",
    permission: CONFIG.forbidden_routes.auth.login,
  },
];

export const mainNavMobileLinks = mobileNav.filter((item) => !item.permission);

const footerNavData = {
  quickLinks: [
    {
      href: "/",
      label: "Home",
      permission: CONFIG.forbidden_routes.layout.home,
    },
    {
      href: "/venues",
      label: "Venues",
      permission: CONFIG.forbidden_routes.layout.venues,
    },
    {
      href: "/book-court",
      label: "Book a Court",
      permission: CONFIG.forbidden_routes.layout.book_court,
    },
    {
      href: "/private-team-lessons",
      label: "Training",
      permission: CONFIG.forbidden_routes.layout.training,
    },
    {
      href: "/membership",
      label: "Membership",
      permission: CONFIG.forbidden_routes.layout.membership,
    },
    {
      href: "/about-us",
      label: "About Us",
      permission: CONFIG.forbidden_routes.layout.about_us,
    },
  ],
  supportLinks: [
    {
      href: "/contact-us",
      label: "Contact Us",
      permission: CONFIG.forbidden_routes.layout.contact_us,
    },
    {
      href: "/faqs",
      label: "FAQ's",
      permission: CONFIG.forbidden_routes.layout.faqs,
    },
    {
      href: "/privacy-policy",
      label: "Privacy Policy",
      permission: CONFIG.forbidden_routes.layout.privacy_policy,
    },
    {
      href: "/terms-condition",
      label: "Terms & Conditions",
      permission: CONFIG.forbidden_routes.layout.terms_conditions,
    },
  ],
  otherLinks: [
    {
      href: "/login",
      label: "Sign In",
      permission: CONFIG.forbidden_routes.auth.login,
    },
    {
      href: "/sign-up",
      label: "Sign Up",
      permission: CONFIG.forbidden_routes.auth.sign_up,
    },
    {
      href: "/booking-query",
      label: "Booking Query",
      permission: CONFIG.forbidden_routes.layout.booking_query,
    },
    {
      href: "/parental-consent-and-liability-waiver",
      label: "Parental Consent Form",
      permission: CONFIG.forbidden_routes.layout.parental_waiver,
    },
    {
      href: "/school-fund-raising-program",
      label: "School Fund Raising",
      permission: CONFIG.forbidden_routes.layout.school_fund_raising_program,
    },
    {
      href: "/badminton-beginners-programs",
      label: "Badminton Kids Beginner",
      permission: CONFIG.forbidden_routes.layout.badminton_beginners_programs,
    },
    {
      href: "/pa-day",
      label: "PA Day",
      permission: CONFIG.forbidden_routes.layout.pa_day_badminton_camp,
    },
    // {
    //   href: "/winter-camp",
    //   label: "Winter Camp",
    //   permission: CONFIG.forbidden_routes.layout.winter_badminton_camp,
    // },
    {
      href: "/blogs",
      label: "Blogs",
      permission: CONFIG.forbidden_routes.layout.blogs,
    },
  ],
  otherAuthLinks: [
    {
      href: "/dashboard",
      label: "Dashboard",
      permission: CONFIG.forbidden_routes.user.dashboard,
    },
    {
      href: "/my-bookings?type=0&tab=0",
      label: "My Bookings",
      permission: CONFIG.forbidden_routes.user.my_bookings,
    },
    {
      href: "/profile",
      label: "My Profile",
      permission: CONFIG.forbidden_routes.user.my_profile,
    },
    {
      href: "/booking-query",
      label: "Booking Query",
      permission: CONFIG.forbidden_routes.user.booking_query,
    },
    {
      href: "/parental-consent-and-liability-waiver",
      label: "Parental Consent Form",
      permission: CONFIG.forbidden_routes.user.parental_waiver,
    },
    {
      href: "/school-fund-raising-program",
      label: "School Fund Raising",
      permission: CONFIG.forbidden_routes.layout.school_fund_raising_program,
    },
    {
      href: "/badminton-beginners-programs",
      label: "Badminton Kids Beginner",
      permission: CONFIG.forbidden_routes.layout.badminton_beginners_programs,
    },
    {
      href: "/pa-day",
      label: "PA Day",
      permission: CONFIG.forbidden_routes.layout.pa_day_badminton_camp,
    },
    // {
    //   href: "/winter-camp",
    //   label: "Winter Camp",
    //   permission: CONFIG.forbidden_routes.layout.winter_badminton_camp,
    // },
    {
      href: "/blogs",
      label: "Blogs",
      permission: CONFIG.forbidden_routes.layout.blogs,
    },
  ],
};

export const footerData = {
  otherAuthLinks: footerNavData.otherAuthLinks.filter(
    (item) => !item.permission,
  ),
  otherLinks: footerNavData.otherLinks.filter((item) => !item.permission),
  supportLinks: footerNavData.supportLinks.filter((item) => !item.permission),
  quickLinks: footerNavData.quickLinks.filter((item) => !item.permission),
};

const userNav = [
  {
    id: "dashboard",
    href: "/dashboard",
    label: "Dashboard",
    icon: dashboardIcon,
    permission: CONFIG.forbidden_routes.user.dashboard,
  },
  {
    id: "my-bookings",
    href: "/my-bookings?type=0&tab=0",
    label: "My Bookings",
    icon: bookingIcon,
    permission: CONFIG.forbidden_routes.user.my_bookings,
  },
  {
    id: "profile",
    href: "/profile",
    label: "Profile",
    icon: profileIcon,
    permission: CONFIG.forbidden_routes.user.my_profile,
  },
  {
    id: "trainees",
    href: "/trainees",
    label: "Trainees",
    icon: traineeIcon,
    permission: CONFIG.forbidden_routes.user.trainees,
  },
  {
    id: "players",
    href: "/drop-in-players",
    label: "Players",
    icon: playerIcon,
    permission: CONFIG.forbidden_routes.user.drop_in_players,
  },
  {
    id: "profile-settings",
    href: "/profile-settings",
    label: "Settings",
    icon: settingsIcon,
    permission: CONFIG.forbidden_routes.user.profile_settings,
  },
];

export const userNavData = userNav.filter((item) => !item.permission);

export const taxData = {
  ...CONFIG.tax_data,
};

export const clientContactData = {
  ...CONFIG.clientContactData,
};

export const profileSettingsNavData = [
  {
    key: "edit-profile",
    label: "Edit Profile",
  },
  {
    key: "change-password",
    label: "Change Password",
  },
];

export const bookingsNavData = [
  {
    key: "upcoming",
    label: "Upcoming",
  },
  {
    key: "completed",
    label: "Completed",
  },
  {
    key: "on-going",
    label: "On Going",
  },
  {
    key: "cancelled",
    label: "Cancelled",
  },
];

export const expertiseData = [
  {
    value: 1,
    label: "Beginner",
  },
  {
    value: 2,
    label: "Intermediate",
  },
  {
    value: 3,
    label: "Master",
  },
];

export const traineeTypeData = [
  {
    value: 2,
    label: "Child (4 to 16)",
  },
  {
    value: 1,
    label: "Adult (16+ to 80)",
  },
];

const tabs_data = [
  {
    label: "Court",
    value: 0,
    permission: CONFIG.forbidden_routes.layout.book_court,
  },
  {
    label: "Coaching",
    value: 1,
    permission: CONFIG.forbidden_routes.layout.training,
  },
  {
    label: "Drop-In",
    value: 2,
    permission: CONFIG.forbidden_routes.layout.drop_in,
  },
];

export const service_tabs = tabs_data.filter(({ permission }) => !permission);

const enrolledForDropdownData = [
  {
    value: 1,
    label: "Court Rental",
    permission: CONFIG.forbidden_routes.layout.book_court,
  },
  {
    value: 2,
    label: "Coaching",
    permission: CONFIG.forbidden_routes.layout.training,
  },
];

export const enrolledForData = enrolledForDropdownData.filter(
  ({ permission }) => !permission,
);

export const dobMaxDate = CONFIG.dobMaxDate;
export const dobMaxDateForChild = CONFIG.dobMaxDateForChild;
export const dobMinDateForChild = CONFIG.dobMinDateForChild;
export const dobMaxDateForAdult = CONFIG.dobMaxDateForAdult;
export const dobMinDateForAdult = CONFIG.dobMinDateForAdult;

export function generateTimeArray() {
  const timeArray = [];
  let idCounter = 1;

  for (let hour = 6; hour <= 23; hour++) {
    timeArray.push({
      id: idCounter,
      value: hour,
      label: `${hour <= 12 ? appendZero(hour) : appendZero(hour - 12)}:00 ${
        hour < 12 ? "AM" : "PM"
      }`,
    });

    idCounter++;
  }

  return timeArray;
}

export const planLevelIcons = {
  1: levelOne,
  2: levelTwo,
  3: levelThree,
};

export const specialDates = ["2024-05-20"];

export const coachLevelArrey = [
  {
    value: 1,
    label: "Pro",
  },
  {
    value: 2,
    label: "Master",
  },
  {
    value: 3,
    label: "Champ",
  },
];

export const shiftIcons = {
  morning: <MorningIcon size={16} />,
  afternoon: <AfternoonIcon size={16} />,
  evening: <EveningIcon size={16} />,
};
